import { Api } from "../Config/request";

const getSuppliers = async () => {
  const response = await Api.GetRequest(`/organisation?expandProduct=true`);
  return response;
};

const getSupplierById = async (data) => {
  const response = await Api.GetRequest(`/organisation/${data.id}`);
  return response;
}

const addSupplier = async (data) => {
  const response = await Api.PostRequest("/organisation", data);
  return response;
};

const deleteSupplier = async (data) => {
  let response = await Api.DeleteRequest(`/organisation/${data.id}`, data);
  return response;
}

const updateSupplier = async (data) => {
  let response = await Api.PutRequest(`/organisation/${data.id}`, data);
  return response;
}

const getSupplierAddress = async (data) => {
  console.log(data);
  
  const response = await Api.GetRequest(`/address/${data}`);
  return response;
}

const supplierApi = { getSuppliers, getSupplierById, updateSupplier, addSupplier, deleteSupplier, getSupplierAddress };

export default supplierApi;
